// src/i18n.jsx
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      nav: {
        home: "Home",
        about: "About Us",
        contact: "Contact Us",
        services: "Services",
        savings: "Savings",
        credit: "Credit",
        jobs: "Jobs/Internships",
        promotions: "Promotions",
        realisations: "Realizations",
        activities: "Activities",
        testimonials: "Testimonials",
        faq: "FAQ",
        teams: "Teams",
      },
      hero: {
        heading: "Welcome to Microtous",
        message: "Let's build our empire.",
        buttonText: "Get Started",
      },
      home: {
        heroWelcome: "Welcome to Microtous",
        heroBadge: "Savings & Credit Microfinance Cooperative",
        heroCta1: "Explore Our Services",
        heroCta2: "Contact Us",
        aboutTitle: "About Us",
        aboutP1: "At COOPEC Microtous, we are a savings and credit cooperative committed to improving the financial lives of our members. Our team of dedicated professionals works every day to provide reliable, accessible services adapted to everyone's needs. With our experience and expertise, we offer innovative solutions that allow our members to secure their finances, realize their projects and plan a stable future.",
        aboutP2: "Our diverse team brings together experts in finance, management and community development, guaranteeing quality advice and solutions. We understand the challenges our members face and we work tirelessly to provide them with safe and sustainable financial support. Whether you want to save, invest or access credit, COOPEC Microtous is your trusted partner to build a prosperous future.",
        aboutMore: "Learn More",
        servicesTitle: "Our Services",
        servicesSubtitle: "Simple, secure and accessible financial solutions for every member.",
        servicesLearn: "Discover More",
        promotionsTitle: "Promotions",
        promotionsSubtitle: "Discover our latest promotions and special offers.",
        promotionsMore: "Learn More",
        activitiesTitle: "Activities",
        activitiesSubtitle: "Discover the various activities we organize to engage our clients and the community.",
        activitiesDate: "Date",
        activitiesTime: "Time",
        activitiesVenue: "Venue",
        jobsTitle: "Jobs & Internships",
        jobsSubtitle: "Join our team! We are always looking for talented people to help us grow.",
        jobsApply: "Apply Now",
        testimonialsTitle: "Testimonials",
        testimonialsSubtitle: "Discover what our clients think about our services.",
        faqTitle: "Frequently Asked Questions (FAQ)",
        faqSubtitle: "Find answers to the most common questions about our services, accounts, credits and more.",
        teamTitle: "Our Team",
        teamSubtitle: "Meet the brilliant minds behind our success. Our team is the backbone of our company.",
        contactTitle: "Contact Us",
        contactName: "Full Name",
        contactNamePlaceholder: "Enter your full name",
        contactEmail: "Email",
        contactEmailPlaceholder: "Enter your email",
        contactMessage: "Message",
        contactMessagePlaceholder: "Write your message here",
        contactSend: "Send",
      },
      about: {
        heroTitle: "About Us",
        who: "Who are we?",
        whoText: "We are a savings and credit cooperative committed to improving financial inclusion and the economic well-being of our members. Our team of dedicated professionals works every day to offer reliable, accessible and quality financial services. With our experience, we provide solutions adapted to the real needs of each member, while contributing to the sustainable development of the community.",
        mission: "Our Mission",
        missionText: "Our mission is to collect our members' savings and manage them securely in order to finance their projects, support their financial needs and promote their economic development. We are committed to offering reliable, accessible and adapted services, while promoting solidarity and financial autonomy within our community.",
        vision: "Our Vision",
        visionText: "Our vision is to build an empire without poverty, where every member of COOPEC Microtous has access to reliable and adapted financial services to improve their life. We aspire to be a cooperative recognized for its innovation, its solidarity and its commitment to supporting the economic success of all our members.",
        valuesTitle: "Our Values",
        value1Title: "Solidarity",
        value1Text: "We support one another and share our resources so that every member can grow and succeed together as a community.",
        value2Title: "Trust",
        value2Text: "We build lasting relationships based on transparency, honesty and mutual respect with every member.",
        value3Title: "Integrity",
        value3Text: "We act with ethics and rigor in everything we do, protecting the interests of our members above all.",
        value4Title: "Excellence",
        value4Text: "We constantly strive to deliver quality, accessible financial services adapted to the real needs of our members.",
      },
      faq: {
        heroTitle: "FAQ (Frequently Asked Questions)",
        title: "Frequently Asked Questions (FAQs)",
        subtitle: "Find answers to the most common questions about our banking services, accounts, loans and more.",
        q1: "How do I open a Savings account?",
        a1: "Account opening costs $5.00 for Current, $10.00 for Maisha and $3.00 for Card Savings; documents required: passport photo and a copy of ID.",
        q2: "What types of Savings accounts do you offer?",
        a2: "Current Savings, Maisha Savings and Card Savings.",
        q3: "How can I apply for a Loan?",
        a3: "Go to the reception and fill in a loan application form, paying the file study fee which is 1% of the requested amount.",
        q4: "What types of Loans do you offer?",
        a4: "Mushahara Loan, Twekambe Loan and Nibuthe Loan.",
        q5: "What is the interest rate on locked savings accounts?",
        a5: "The interest rate for locked savings is 2% per month.",
        q6: "Can I access my account from anywhere in the world?",
        a6: "No, for the moment it is only in DRC.",
        helpTitle: "Still have questions?",
        helpSubtitle: "Our team is happy to help you with your accounts, savings and credits.",
        helpCta: "Contact our team",
      },
      contact: {
        heroTitle: "Contact Us",
        title: "Contact Us",
        name: "Name",
        namePlaceholder: "Your name",
        email: "Email",
        emailPlaceholder: "Your email",
        message: "Message",
        messagePlaceholder: "Your message",
        send: "Send message",
        openMap: "Open in Google Maps",
        error: "There was a problem sending your message. Please try again later.",
        success: "Thank you for your message! We will get back to you soon.",
      },
      activities: {
        heroTitle: "Activities",
        title: "Activities",
        subtitle: "Discover the various activities we organize to engage our clients and the community.",
        date: "Date",
        time: "Time",
        venue: "Venue",
        loading: "Loading...",
        errorPrefix: "Error",
      },
      services: {
        heroTitle: "Our Services",
        title: "What We Offer",
        subtitle: "Simple, secure and accessible financial solutions tailored to every member, from savings to credit.",
        more: "Learn More",
        ctaTitle: "Ready to become a member?",
        ctaText: "Open your savings account today and start building a secure financial future with COOPEC Microtous.",
        ctaBtn: "Open an Account",
        error: "Failed to fetch services. Please try again.",
      },
      testimonials: {
        heroTitle: "Testimonials",
        title: "Testimonials",
        subtitle: "Discover what our clients say about our services.",
      },
      jobs: {
        heroTitle: "Jobs and Internships",
        title: "Jobs and Internships",
        subtitle: "Join our team! We are always looking for talented people to help us grow.",
        apply: "Apply",
        error: "Failed to fetch jobs. Please try again.",
        errorPrefix: "Error",
        comingSoon: "No job vacancies are available at the moment. Please check back soon!",
      },
      internship: {
        title: "Internship",
        subtitle: "Looking to gain professional experience? Apply for an internship with COOPEC Microtous.",
        cta: "Request an Internship",
      },
      application: {
        title: "Internship Request Form",
        forJob: "Application for:",
        fullName: "Full Name",
        email: "Email",
        place: "Place",
        placePlaceholder: "Bunia, DRC",
        nationality: "Nationality",
        nationalityPlaceholder: "Select nationality",
        nationalityCongolese: "Congolese",
        nationalityKenyan: "Kenyan",
        nationalityRwandan: "Rwandan",
        sex: "Sex",
        sexPlaceholder: "Select sex",
        sexMale: "Male",
        sexFemale: "Female",
        cv: "CV",
        coverLetter: "Cover Letter",
        otherDocuments: "Other Documents",
        experience: "Years of Experience",
        experiencePlaceholder: "Select experience level",
        experienceBeginner: "Beginner",
        experienceIntermediate: "Intermediate",
        experienceAdvanced: "Advanced",
        startDate: "Start Date",
        submit: "Submit",
        toastSuccessTitle: "Application submitted.",
        toastSuccessDesc: "Your application has been successfully submitted!",
        toastInvalidTitle: "Invalid input.",
        toastInvalidDesc: 'The "sex" field must be either "male" or "female".',
        toastNetworkTitle: "Network error.",
        toastNetworkDesc: "Please check your internet connection and try again.",
        toastFailedTitle: "Submission failed.",
        imageAlt: "Application",
      },
      credit: {
        heroTitle: "Credit",
        title: "The Credits We Offer",
        subtitle: "A well-managed credit opens the way to great projects. We offer three types of loans adapted to your needs.",
        requirementsTitle: "Credit Conditions",
        requirementsSubtitle: "To obtain a credit, our members must meet the following conditions.",
        conditionLabel: "Condition",
        labelTaux: "Rate",
        labelRemboursement: "Repayment",
        labelEcheance: "Maturity",
        labelGarantie: "Financial guarantee",
        membershipNote: "To benefit from a credit, our members must join the cooperative. Membership fees are $20 and the member must have at least 2 months of membership.",
        feesTitle: "Fees to pay (credit related)",
        feeDossier: "Application file study fee",
        feeDecaissement: "Disbursement fee",
        feeAssurance: "Credit insurance fee",
        feeCarnet: "Credit booklet fee (for those who do not have one)",
        applyCta: "Request a credit",
      },
      epargne: {
        heroTitle: "Savings",
        title: "Our Savings Services",
        subtitle: "Secure savings products designed to help you prepare for the future with confidence.",
        intro: "Today's savings are tomorrow's security: with our Current Savings for your immediate projects and our Maisha Savings to build your future.",
        ctaTitle: "Open an Account Online",
        ctaText: "Start building your savings today. Send your request and our team will contact you to complete your account opening.",
        ctaBtn: "Open My Account",
      },
      promotions: {
        heroTitle: "Promotions",
        title: "Promotions",
        subtitle: "Discover our latest promotions and special offers.",
        loading: "Loading...",
        errorPrefix: "Error",
        startDate: "Starts:",
        dueDate: "Ends:",
        comingSoon: "No current promotions. Check back soon!",
      },
      realisations: {
        heroTitle: "Realizations",
        title: "Our Realizations",
        subtitle: "Discover the projects and achievements of COOPEC Microtous.",
        loading: "Loading...",
        errorPrefix: "Error",
        location: "Location:",
        comingSoon: "No realizations published yet. Check back soon!",
      },
      admin: {
        title: "Admin Dashboard",
        loginTitle: "Admin Login",
        email: "Email",
        password: "Password",
        signIn: "Sign In",
        signOut: "Sign Out",
        tabPromotions: "Promotions",
        tabRealisations: "Realizations",
        tabJobs: "Jobs",
        tabApplications: "Applications",
        newPromotion: "New Promotion",
        newRealisation: "New Realization",
        newJob: "New Job Posting",
        contractType: "Contract type",
        contractFullTime: "Full-time",
        contractPartTime: "Part-time",
        contractInternship: "Internship",
        contractTemporary: "Temporary",
        contractVolunteer: "Volunteer",
        salary: "Salary",
        deadline: "Application deadline",
        itemTitle: "Title",
        description: "Description",
        image: "Image",
        startDate: "Start date",
        endDate: "End date",
        location: "Location",
        publish: "Publish",
        unpublish: "Unpublish",
        draft: "Draft",
        publishImmediately: "Publish immediately on the website",
        update: "Update",
        updated: "Changes saved!",
        cancel: "Cancel",
        editing: "You are editing an existing item.",
        removeImage: "Remove image",
        notSpecified: "Not specified",
        delete: "Delete",
        confirmDelete: "Delete this item? This cannot be undone.",
        noItems: "Nothing published yet.",
        created: "Published successfully!",
        deleted: "Item deleted.",
        saving: "Saving...",
        loginError: "Invalid email or password.",
        notConfigured: "Supabase is not configured. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in .env, then restart the app.",
        imageRequired: "Please choose an image.",
        invalidImageType: "The selected file is not an image.",
        fileTooLarge: "The image is too large. The maximum size is 5 MB.",
        uploadForbidden: "Your account is not allowed to upload files. Add it to the admin_users table in Supabase (see supabase/README.md).",
        notAdminWarning: "This account is not listed as an administrator, so uploading and publishing will fail. Add it to the admin_users table in Supabase (see supabase/README.md).",
        titleRequired: "Please provide a title in at least one language.",
        errorPrefix: "Error",
        noApplications: "No application received yet.",
        viewDocument: "Open document",
        cv: "CV",
        coverLetter: "Cover letter",
        otherDocuments: "Other documents",
      },
      teams: {
        heroTitle: "Teams",
        title: "Our Team",
        subtitle: "Meet the brilliant minds behind our success. Our team is the backbone of our company.",
        seeAll: "See all team members",
      },
      footer1: {
        tagline: "A savings and credit cooperative committed to building a prosperous and secure financial future for our members in Bunia.",
        links: "Links",
        home: "Home",
        about: "About",
        services: "Services",
        contact: "Contact",
        others: "Others",
        products: "Products",
        savings: "Savings",
        credit: "Credit",
        healthInsurance: "Health Insurance",
        promotions: "Promotions",
        activities: "Activities",
        contactTitle: "Contact Us and Schedule",
        address: "018 Avenue de l'Église, Ngezi Quarter, Mbunya Commune, Bunia, Ituri, DRC",
        email: "Email : info@microtous.com / support@microtous.com",
        phone: "Phone : +243 820 937 002",
        monFri: "Monday to Friday: 08:00 - 17:00",
        sat: "Saturday: 08:00 - 12:00",
        logoAlt: "Company logo",
        rights: "All rights reserved.",
        phoneNumber: "+243 820 937 002",
        emailAddress: "info@microtous.com / support@microtous.com",
        city: "Bunia, Ituri, DRC",
        downloadBrochure: "Download our brochure",
      },
      chatbot: {
        ariaLabel: "Chat with us on WhatsApp",
      },
    },
  },
  fr: {
    translation: {
      nav: {
        home: "Accueil",
        about: "À propos de nous",
        contact: "Contactez-nous",
        services: "Services",
        savings: "Épargne",
        credit: "Crédit",
        jobs: "Offre/Stage",
        promotions: "Promotion",
        realisations: "Réalisations",
        activities: "Activités",
        testimonials: "Témoignages",
        faq: "FAQ",
        teams: "Équipes",
      },
      hero: {
        heading: "Bienvenu chez microtous",
        message: "Bâtissons notre empire.",
        buttonText: "Commencer",
      },
      home: {
        heroWelcome: "Bienvenu chez microtous",
        heroBadge: "Coopérative d'épargne et de crédit microfinance pour tous",
        heroCta1: "Découvrir nos services",
        heroCta2: "Contactez-nous",
        aboutTitle: "À propos de nous",
        aboutP1: "À la COOPEC Microtous, nous sommes une coopérative d'épargne et de crédit engagée à améliorer la vie financière de nos membres. Notre équipe de professionnels dévoués œuvre chaque jour pour offrir des services fiables, accessibles et adaptés aux besoins de chacun. Forts de notre expérience et de notre expertise, nous proposons des solutions innovantes qui permettent à nos membres de sécuriser leurs finances, de réaliser leurs projets et de planifier un avenir stable.",
        aboutP2: "Notre équipe diversifiée réunit des experts en finance, gestion et développement communautaire, garantissant des conseils et des solutions de qualité. Nous comprenons les défis auxquels nos membres sont confrontés et nous travaillons sans relâche pour leur fournir un soutien financier sûr et durable. Que vous souhaitiez épargner, investir ou accéder à un crédit, la COOPEC Microtous est votre partenaire de confiance pour bâtir un avenir prospère.",
        aboutMore: "En savoir plus",
        servicesTitle: "Nos Services",
        servicesSubtitle: "Des solutions financières simples, sécurisées et accessibles pour chaque membre.",
        servicesLearn: "Découvrir",
        promotionsTitle: "Promotions",
        promotionsSubtitle: "Découvrez nos dernières promotions et offres spéciales.",
        promotionsMore: "En savoir plus",
        activitiesTitle: "Activités",
        activitiesSubtitle: "Découvrez les différentes activités que nous organisons pour engager nos clients et la communauté.",
        activitiesDate: "Date",
        activitiesTime: "Heure",
        activitiesVenue: "Lieu",
        jobsTitle: "Emplois & Stages",
        jobsSubtitle: "Rejoignez notre équipe ! Nous sommes toujours à la recherche de personnes talentueuses pour nous aider à grandir.",
        jobsApply: "Postulez maintenant",
        testimonialsTitle: "Témoignages",
        testimonialsSubtitle: "Découvrez ce que nos clients pensent de nos services.",
        faqTitle: "Questions fréquemment posées (FAQ)",
        faqSubtitle: "Trouvez des réponses aux questions les plus courantes concernant nos services, comptes, Crédits, et plus encore.",
        teamTitle: "Notre équipe",
        teamSubtitle: "Rencontrez les esprits brillants derrière notre succès. Notre équipe est l'épine dorsale de notre entreprise.",
        contactTitle: "Contactez-nous",
        contactName: "Nom complet",
        contactNamePlaceholder: "Entrez votre nom complet",
        contactEmail: "Email",
        contactEmailPlaceholder: "Entrez votre email",
        contactMessage: "Message",
        contactMessagePlaceholder: "Écrivez votre message ici",
        contactSend: "Envoyer",
      },
      about: {
        heroTitle: "À propos de nous",
        who: "Qui sommes-nous ?",
        whoText: "Nous sommes une coopérative d'épargne et de crédit engagée à améliorer l'inclusion financière et le bien-être économique de nos membres. Notre équipe de professionnels dévoués œuvre chaque jour pour offrir des services financiers fiables, accessibles et de qualité. Forts de notre expérience, nous proposons des solutions adaptées aux besoins réels de chaque membre, tout en contribuant au développement durable de la communauté.",
        mission: "Notre mission",
        missionText: "Notre mission est de collecter les épargnes de nos membres et de les gérer de manière sécurisée afin de financer leurs projets, soutenir leurs besoins financiers et favoriser leur développement économique. Nous nous engageons à offrir des services fiables, accessibles et adaptés, tout en promouvant la solidarité et l'autonomie financière au sein de notre communauté.",
        vision: "Notre vision",
        visionText: "Notre vision est de bâtir un Empire sans pauvreté, où chaque membre de la COOPEC Microtous a accès à des services financiers fiables et adaptés pour améliorer sa vie. Nous aspirons à être une coopérative reconnue pour son innovation, sa solidarité et son engagement à soutenir la réussite économique de tous nos membres.",
        valuesTitle: "Nos Valeurs",
        value1Title: "Solidarité",
        value1Text: "Nous nous soutenons mutuellement et mutualisons nos ressources afin que chaque membre puisse grandir et réussir ensemble en tant que communauté.",
        value2Title: "Confiance",
        value2Text: "Nous bâtissons des relations durables fondées sur la transparence, l'honnêteté et le respect mutuel avec chaque membre.",
        value3Title: "Intégrité",
        value3Text: "Nous agissons avec éthique et rigueur dans tout ce que nous faisons, protégeant avant tout les intérêts de nos membres.",
        value4Title: "Excellence",
        value4Text: "Nous nous efforçons constamment de fournir des services financiers de qualité, accessibles et adaptés aux besoins réels de nos membres.",
      },
      faq: {
        heroTitle: "FAQ (Questions fréquemment posées)",
        title: "Questions Fréquentes (FAQs)",
        subtitle: "Trouvez des réponses aux questions les plus courantes concernant nos services bancaires, comptes, prêts et plus encore.",
        q1: "Comment ouvrir un compte Epagne ?",
        a1: "L'ouverture de compte est à $ 5.00 si c'est Courant $ 10.00 Maisha et $ 3.00 Epargne a la Carte; les documents à présenter sont: Photo passeport, et une copie de pièce d'identité",
        q2: "Quels types de comptes Epargne proposez-vous ?",
        a2: "Epargne Courant, Epargne Maisha et Epargne à la Carte.",
        q3: "Comment puis-je demander un Credit ?",
        a3: "Passez à La réception et remplissez fiche de demande de crédit, moyant le frais d'Etude de Dossier qui est le 1% du montant demandé",
        q4: "Quels types de Crédit proposez-vous ?",
        a4: "Crédit Mushahara, Crédit Twekambe et Crédit Nibuthe.",
        q5: "Quel est le taux d'intérêt des comptes d'épargne Bloqués?",
        a5: "Le taux d'intérêt pour l'epargne bloqué est de 2% mensuel.",
        q6: "Puis-je accéder à mon compte depuis n'importe où dans le monde ?",
        a6: "Non, pour le moment c'est seulement à la RDC.",
        helpTitle: "Encore des questions ?",
        helpSubtitle: "Notre équipe se fera un plaisir de vous aider pour vos comptes, épargnes et crédits.",
        helpCta: "Contacter notre équipe",
      },
      contact: {
        heroTitle: "Contactez-nous",
        title: "Contactez-nous",
        name: "Nom",
        namePlaceholder: "Votre nom",
        email: "Email",
        emailPlaceholder: "Votre email",
        message: "Message",
        messagePlaceholder: "Votre message",
        send: "Envoyer le message",
        openMap: "Ouvrir dans Google Maps",
        error: "Il y a eu un problème lors de l'envoi de votre message. Veuillez réessayer plus tard.",
        success: "Merci pour votre message ! Nous reviendrons vers vous bientôt.",
      },
      activities: {
        heroTitle: "Activités",
        title: "Activités",
        subtitle: "Découvrez les différentes activités que nous organisons pour engager nos clients et la communauté.",
        date: "Date",
        time: "Heure",
        venue: "Lieu",
        loading: "Chargement...",
        errorPrefix: "Erreur",
      },
services: {
        heroTitle: "Nos Services",
        title: "Ce que nous offrons",
        subtitle: "Des solutions financières simples, sécurisées et accessibles adaptées à chaque membre, de l'épargne au crédit.",
        more: "En savoir plus",
        ctaTitle: "Prêt à devenir membre ?",
        ctaText: "Ouvrez votre compte d'épargne dès aujourd'hui et commencez à bâtir un avenir financier sûr avec la COOPEC Microtous.",
        ctaBtn: "Ouvrir un compte",
        error: "Échec du chargement des services. Veuillez réessayer.",
      },
      testimonials: {
        heroTitle: "Témoignages",
        title: "Témoignages",
        subtitle: "Découvrez ce que nos clients disent de nos services.",
      },
      jobs: {
        heroTitle: "Emplois et Stages",
        title: "Emplois et Stages",
        subtitle: "Rejoignez notre équipe ! Nous cherchons toujours des personnes talentueuses pour nous aider à grandir.",
        apply: "Postuler",
        error: "Échec de la récupération des emplois. Veuillez réessayer.",
        errorPrefix: "Erreur",
        comingSoon: "Aucun poste vacant pour le moment. Revenez bientôt !",
      },
      internship: {
        title: "Stage",
        subtitle: "Vous cherchez à acquérir une expérience professionnelle ? Postulez pour un stage à la COOPEC Microtous.",
        cta: "Demander un stage",
      },
      application: {
        title: "Formulaire de demande de stage",
        forJob: "Candidature pour :",
        fullName: "Nom Complet",
        email: "Email",
        place: "Lieu",
        placePlaceholder: "Bunia, RDC",
        nationality: "Nationalité",
        nationalityPlaceholder: "Sélectionner la nationalité",
        nationalityCongolese: "Congolaise",
        nationalityKenyan: "Kényane",
        nationalityRwandan: "Rwandaise",
        sex: "Sexe",
        sexPlaceholder: "Sélectionner le sexe",
        sexMale: "Homme",
        sexFemale: "Femme",
        cv: "CV",
        coverLetter: "Lettre de Motivation",
        otherDocuments: "Autres Documents",
        experience: "Années d'Expérience",
        experiencePlaceholder: "Sélectionner le niveau d'expérience",
        experienceBeginner: "Débutant",
        experienceIntermediate: "Intermédiaire",
        experienceAdvanced: "Avancé",
        startDate: "Date de Début",
        submit: "Soumettre",
        toastSuccessTitle: "Candidature soumise.",
        toastSuccessDesc: "Votre candidature a été soumise avec succès !",
        toastInvalidTitle: "Entrée invalide.",
        toastInvalidDesc: 'Le champ "sexe" doit être "male" ou "female".',
        toastNetworkTitle: "Erreur réseau.",
        toastNetworkDesc: "Veuillez vérifier votre connexion internet et réessayer.",
        toastFailedTitle: "Échec de la soumission.",
        imageAlt: "Candidature",
      },
      credit: {
        heroTitle: "Credit",
        title: "Les Crédits que nous offrons",
        subtitle: "Un crédit bien géré ouvre la voie à de grands projets. Nous proposons trois types de crédits adaptés à vos besoins.",
        requirementsTitle: "Conditions de crédit",
        requirementsSubtitle: "Pour obtenir un crédit, nos membres doivent remplir les conditions suivantes.",
        conditionLabel: "Condition",
        labelTaux: "Taux",
        labelRemboursement: "Remboursement",
        labelEcheance: "Échéance",
        labelGarantie: "Garantie financière",
        membershipNote: "Pour bénéficier d’un crédit, nos membres doivent adhérer. Les frais d’adhésion s’élèvent à 20 $. De plus, le membre doit justifier d’au moins 2 mois d’ancienneté.",
        feesTitle: "Les frais à payer (liés au crédit)",
        feeDossier: "Frais d’étude de dossier",
        feeDecaissement: "Frais de décaissement",
        feeAssurance: "Frais d’assurance crédit",
        feeCarnet: "Frais de carnet de crédit (pour celui qui n’en possède pas)",
        applyCta: "Demander un crédit",
      },
      epargne: {
        heroTitle: "Epargne",
        title: "Nos services d'Épargne",
        subtitle: "Des produits d'épargne sécurisés conçus pour vous aider à préparer l'avenir en toute confiance.",
        intro: "L’épargne d’aujourd’hui est la sécurité de demain : avec notre Épargne Courant pour vos projets immédiats et notre Épargne Maisha pour construire votre avenir.",
        ctaTitle: "Ouvrir un compte en ligne",
        ctaText: "Commencez à épargner dès aujourd'hui. Envoyez votre demande et notre équipe vous contactera pour finaliser l'ouverture de votre compte.",
        ctaBtn: "Ouvrir mon compte",
      },
      promotions: {
        heroTitle: "Promotions",
        title: "Promotions",
        subtitle: "Découvrez nos dernières promotions et offres spéciales.",
        loading: "Chargement...",
        errorPrefix: "Erreur",
        startDate: "Début :",
        dueDate: "Fin :",
        comingSoon: "Aucune promotion en cours. Revenez bientôt !",
      },
      realisations: {
        heroTitle: "Réalisations",
        title: "Nos Réalisations",
        subtitle: "Découvrez les projets et réalisations de COOPEC Microtous.",
        loading: "Chargement...",
        errorPrefix: "Erreur",
        location: "Lieu :",
        comingSoon: "Aucune réalisation publiée pour le moment. Revenez bientôt !",
      },
      admin: {
        title: "Tableau de bord Admin",
        loginTitle: "Connexion Admin",
        email: "Email",
        password: "Mot de passe",
        signIn: "Se connecter",
        signOut: "Se déconnecter",
        tabPromotions: "Promotions",
        tabRealisations: "Réalisations",
        tabJobs: "Offres d'emploi",
        tabApplications: "Candidatures",
        newPromotion: "Nouvelle promotion",
        newRealisation: "Nouvelle réalisation",
        newJob: "Nouvelle offre d'emploi",
        contractType: "Type de contrat",
        contractFullTime: "Temps plein",
        contractPartTime: "Temps partiel",
        contractInternship: "Stage",
        contractTemporary: "Temporaire",
        contractVolunteer: "Bénévolat",
        salary: "Salaire",
        deadline: "Date limite de candidature",
        itemTitle: "Titre",
        description: "Description",
        image: "Image",
        startDate: "Date de début",
        endDate: "Date de fin",
        location: "Lieu",
        publish: "Publier",
        unpublish: "Dépublier",
        draft: "Brouillon",
        publishImmediately: "Publier immédiatement sur le site",
        update: "Mettre à jour",
        updated: "Modifications enregistrées !",
        cancel: "Annuler",
        editing: "Vous modifiez un élément existant.",
        removeImage: "Retirer l'image",
        notSpecified: "Non précisé",
        delete: "Supprimer",
        confirmDelete: "Supprimer cet élément ? Cette action est irréversible.",
        noItems: "Rien n'est publié pour le moment.",
        created: "Publié avec succès !",
        deleted: "Élément supprimé.",
        saving: "Enregistrement...",
        loginError: "Email ou mot de passe invalide.",
        notConfigured: "Supabase n'est pas configuré. Renseignez REACT_APP_SUPABASE_URL et REACT_APP_SUPABASE_ANON_KEY dans .env puis redémarrez l'application.",
        imageRequired: "Veuillez choisir une image.",
        invalidImageType: "Le fichier sélectionné n'est pas une image.",
        fileTooLarge: "L'image est trop lourde. La taille maximale est de 5 Mo.",
        uploadForbidden: "Votre compte n'est pas autorisé à envoyer des fichiers. Ajoutez-le à la table admin_users dans Supabase (voir supabase/README.md).",
        notAdminWarning: "Ce compte n'est pas répertorié comme administrateur : l'envoi de fichiers et la publication échoueront. Ajoutez-le à la table admin_users dans Supabase (voir supabase/README.md).",
        titleRequired: "Veuillez fournir un titre dans au moins une langue.",
        errorPrefix: "Erreur",
        noApplications: "Aucune candidature reçue pour le moment.",
        viewDocument: "Ouvrir le document",
        cv: "CV",
        coverLetter: "Lettre de motivation",
        otherDocuments: "Autres documents",
      },
      teams: {
        heroTitle: "Teams",
        title: "Notre Équipe",
        subtitle: "Rencontrez les esprits brillants derrière notre succès. Notre équipe est la colonne vertébrale de notre entreprise.",
        seeAll: "Voir toute l'équipe",
      },
      footer1: {
        tagline: "Une coopérative d'épargne et de crédit engagée à bâtir un avenir financier prospère et sécurisé pour nos membres à Bunia.",
        links: "Liens",
        home: "Accueil",
        about: "À propos",
        services: "Services",
        contact: "Contact",
        others: "Autres",
        products: "Produits",
        savings: "Epargne",
        credit: "Crédit",
        healthInsurance: "Assurance Santé",
        promotions: "Promotions",
        activities: "Activités",
        contactTitle: "Contactez-nous et Horaire",
        address: "018 Avenue de l'Église, Quartier Ngezi, Commune Mbunya, Bunia, Ituri, RDC",
        email: "Email : info@microtous.com / support@microtous.com",
        phone: "Téléphone : +243 820 937 002",
        monFri: "Lundi au Vendredi : 08h00 - 17h00",
        sat: "Samedi : 08h00 - 12h00",
        logoAlt: "Logo de la société",
        rights: "Tous droits réservés.",
        phoneNumber: "+243 820 937 002",
        emailAddress: "info@microtous.com / support@microtous.com",
        city: "Bunia, Ituri, RDC",
        downloadBrochure: "Télécharger notre dépliant",
      },
      chatbot: {
        ariaLabel: "Discutez avec nous sur WhatsApp",
      },
    },
  },
  sw: {
    translation: {
      nav: {
        home: "Nyumbani",
        about: "Kuhusu Sisi",
        contact: "Wasiliana Nasi",
        services: "Huduma",
        savings: "Akiba",
        credit: "Mikopo",
        jobs: "Kazi/Mafunzo",
        promotions: "Matangazo",
        realisations: "Matendo",
        activities: "Shughuli",
        testimonials: "Ushuhuda",
        faq: "Maswali",
        teams: "Timu",
      },
      hero: {
        heading: "Karibu Microtous",
        message: "Tujenge ufalme wetu.",
        buttonText: "Anza",
      },
      home: {
        heroWelcome: "Karibu Microtous",
        heroBadge: "Ushirika wa akiba na mikopo wa mikrofedha kwa wote",
        heroCta1: "Gundua huduma zetu",
        heroCta2: "Wasiliana nasi",
        aboutTitle: "Kuhusu Sisi",
        aboutP1: "Katika COOPEC Microtous, sisi ni ushirika wa akiba na mikopo uliojitolea kuboresha maisha ya kifedha ya wanachama wetu. Timu yetu ya wataalamu wenye kujitolea hufanya kazi kila siku kutoa huduma za kuaminika, zinazoweza kupatikana na zinazolingana na mahitaji ya kila mtu. Kwa uzoefu wetu, tunatoa suluhisho bunifu zinazowawezesha wanachama wetu kulinda fedha zao, kutimiza miradi yao na kupanga mustakabali thabiti.",
        aboutP2: "Timu yetu yenye utofauti ina wataalamu wa fedha, usimamizi na maendeleo ya jamii, ikihakikisha ushauri na suluhisho bora. Tunaelewa changamoto ambazo wanachama wetu wanakabiliana nazo na tunafanya kazi bila kuchoka kuwapa msaada wa kifedha salama na endelevu. Iwe unataka kuweka akiba, kuwekeza au kupata mkopo, COOPEC Microtous ni mshirika wako wa kuaminika wa kujenga mustakabali wenye mafanikio.",
        aboutMore: "Jifunze Zaidi",
        servicesTitle: "Huduma Zetu",
        servicesSubtitle: "Suluhisho rahisi, salama na zinazopatikana za kifedha kwa kila mwanachama.",
        servicesLearn: "Gundua",
        promotionsTitle: "Matangazo",
        promotionsSubtitle: "Gundua matangazo yetu ya hivi karibuni na ofa maalum.",
        promotionsMore: "Jifunze Zaidi",
        activitiesTitle: "Shughuli",
        activitiesSubtitle: "Gundua shughuli mbalimbali tunazopanga kuhusisha wateja wetu na jamii.",
        activitiesDate: "Tarehe",
        activitiesTime: "Muda",
        activitiesVenue: "Mahali",
        jobsTitle: "Kazi na Mafunzo",
        jobsSubtitle: "Jiunge na timu yetu! Daima tunatafuta watu wenye talanta kutusaidia kukua.",
        jobsApply: "Omba Sasa",
        testimonialsTitle: "Ushuhuda",
        testimonialsSubtitle: "Gundua wanachama wetu wanasema nini kuhusu huduma zetu.",
        faqTitle: "Maswali Yanayoulizwa Mara kwa Mara (FAQ)",
        faqSubtitle: "Pata majibu ya maswali ya kawaida kuhusu huduma zetu, akaunti, mikopo na mengine zaidi.",
        teamTitle: "Timu Yetu",
        teamSubtitle: "Kutana na akili nzuri nyuma ya mafanikio yetu. Timu yetu ndio msingi wa kampuni yetu.",
        contactTitle: "Wasiliana Nasi",
        contactName: "Jina Kamili",
        contactNamePlaceholder: "Ingiza jina lako kamili",
        contactEmail: "Barua Pepe",
        contactEmailPlaceholder: "Ingiza barua pepe yako",
        contactMessage: "Ujumbe",
        contactMessagePlaceholder: "Andika ujumbe wako hapa",
        contactSend: "Tuma",
      },
      about: {
        heroTitle: "Kuhusu Sisi",
        who: "Sisi ni nani?",
        whoText: "Sisi ni ushirika wa akiba na mikopo uliojitolea kuboresha ujumuishaji wa kifedha na ustawi wa kiuchumi wa wanachama wetu. Timu yetu ya wataalamu wenye kujitolea hufanya kazi kila siku kutoa huduma za kifedha za kuaminika, zinazoweza kupatikana na bora. Kwa uzoefu wetu, tunatoa suluhisho zinazolingana na mahitaji halisi ya kila mwanachama, huku tukichangia maendeleo endelevu ya jamii.",
        mission: "Dhamira Yetu",
        missionText: "Dhamira yetu ni kukusanya akiba za wanachama wetu na kuzisimamia kwa usalama ili kufadhili miradi yao, kusaidia mahitaji yao ya kifedha na kukuza maendeleo yao ya kiuchumi. Tunajitolea kutoa huduma za kuaminika, zinazoweza kupatikana na zinazolingana, huku tukikuza mshikamano na uhuru wa kifedha ndani ya jamii yetu.",
        vision: "Maono Yetu",
        visionText: "Maono yetu ni kujenga ufalme usio na umaskini, ambapo kila mwanachama wa COOPEC Microtous anapata huduma za kifedha za kuaminika na zinazofaa kuboresha maisha yake. Tunatamani kuwa ushirika unaotambuliwa kwa uvumbuzi wake, mshikamano wake na kujitolea kwake kusaidia mafanikio ya kiuchumi ya wanachama wetu wote.",
        valuesTitle: "Maadili Yetu",
        value1Title: "Mshikamano",
        value1Text: "Tunajisadia kwa ushirikiano na kugawana rasilimali zetu ili kila mwanachama aweze kukua na kufanikiwa pamoja kama jamii.",
        value2Title: "Uaminifu",
        value2Text: "Tunajenga uhusiano wa kudumu kwa misingi ya uwazi, uaminifu na heshima ya pamoja na kila mwanachama.",
        value3Title: "Uadilifu",
        value3Text: "Tunatenda kwa maadili na ukakamavu katika kila kitu tunachofanya, tukilinda maslahi ya wanachama wetu kwanza.",
        value4Title: "Ubora",
        value4Text: "Tunajitahidi kila mara kutoa huduma za kifedha za ubora, zinazopatikana na zinazolingana na mahitaji halisi ya wanachama wetu.",
      },
      faq: {
        heroTitle: "FAQ (Maswali Yanayoulizwa Mara kwa Mara)",
        title: "Maswali Yanayoulizwa Mara kwa Mara (FAQs)",
        subtitle: "Pata majibu ya maswali ya kawaida kuhusu huduma zetu za benki, akaunti, mikopo na mengine zaidi.",
        q1: "Je, ninafunguaje akaunti ya Akiba?",
        a1: "Ufunguzi wa akaunti ni $5.00 kwa Courant, $10.00 kwa Maisha na $3.00 kwa Akiba kwa Kadi; nyaraka zinazohitajika ni: picha ya pasipoti, na nakala ya kitambulisho.",
        q2: "Je, mnatoa aina gani za akaunti za Akiba?",
        a2: "Akiba Courant, Akiba Maisha na Akiba kwa Kadi.",
        q3: "Je, ninawezaje kuomba Mkopo?",
        a3: "Nenda kwenye ukumbi wa mapokezi na ujaze fomu ya maombi ya mkopo, ukilipa ada ya uchunguzi wa faili ambayo ni 1% ya kiasi kilichoombwa.",
        q4: "Je, mnatoa aina gani za Mikopo?",
        a4: "Mkopo wa Mushahara, Mkopo wa Twekambe na Mkopo wa Nibuthe.",
        q5: "Je, kiwango cha riba kwa akaunti za akiba zilizofungwa ni kipi?",
        a5: "Kiwango cha riba cha akiba iliyofungwa ni 2% kwa mwezi.",
        q6: "Je, ninaweza kufikia akaunti yangu kutoka popote duniani?",
        a6: "Hapana, kwa sasa ni katika DRC tu.",
        helpTitle: "Bado una maswali?",
        helpSubtitle: "Timu yetu inafurahia kukusaidia na akaunti zako, akiba na mikopo.",
        helpCta: "Wasiliana na timu yetu",
      },
      contact: {
        heroTitle: "Wasiliana Nasi",
        title: "Wasiliana Nasi",
        name: "Jina",
        namePlaceholder: "Jina lako",
        email: "Barua Pepe",
        emailPlaceholder: "Barua pepe yako",
        message: "Ujumbe",
        messagePlaceholder: "Ujumbe wako",
        send: "Tuma ujumbe",
        openMap: "Fungua Google Maps",
        error: "Kulikuwa na tatizo katika kutuma ujumbe wako. Tafadhali jaribu tena baadaye.",
        success: "Asante kwa ujumbe wako! Tutawasiliana nawe hivi karibuni.",
      },
      activities: {
        heroTitle: "Shughuli",
        title: "Shughuli",
        subtitle: "Gundua shughuli mbalimbali tunazopanga kuhusisha wateja wetu na jamii.",
        date: "Tarehe",
        time: "Muda",
        venue: "Mahali",
        loading: "Inapakia...",
        errorPrefix: "Hitilafu",
      },
      services: {
        heroTitle: "Huduma Zetu",
        title: "Tunachotoa",
        subtitle: "Suluhisho rahisi, salama na zinazopatikana za kifedha kwa kila mwanachama, kuanzia akiba hadi mikopo.",
        more: "Jifunze Zaidi",
        ctaTitle: "Uko tayari kuwa mwanachama?",
        ctaText: "Fungua akaunti yako ya akiba leo na uanze kujenga mustakabali salama wa kifedha na COOPEC Microtous.",
        ctaBtn: "Fungua Akaunti",
        error: "Imeshindikana kupata huduma. Tafadhali jaribu tena.",
      },
      testimonials: {
        heroTitle: "Ushuhuda",
        title: "Ushuhuda",
        subtitle: "Gundua wanachama wetu wanasema nini kuhusu huduma zetu.",
      },
      jobs: {
        heroTitle: "Kazi na Mafunzo",
        title: "Kazi na Mafunzo",
        subtitle: "Jiunge na timu yetu! Daima tunatafuta watu wenye talanta kutusaidia kukua.",
        apply: "Omba",
        error: "Imeshindikana kupata kazi. Tafadhali jaribu tena.",
        errorPrefix: "Hitilafu",
        comingSoon: "Hakuna nafasi za kazi kwa sasa. Tafadhali rejea karibuni!",
      },
      internship: {
        title: "Mafunzo",
        subtitle: "Unataka kupata uzoefu wa kitaaluma? Omba mafunzo kwenye COOPEC Microtous.",
        cta: "Omba Mafunzo",
      },
      application: {
        title: "Fomu ya Maombi ya Mafunzo",
        forJob: "Ombi kwa:",
        fullName: "Jina Kamili",
        email: "Barua Pepe",
        place: "Mahali",
        placePlaceholder: "Bunia, DRC",
        nationality: "Utaifa",
        nationalityPlaceholder: "Chagua utaifa",
        nationalityCongolese: "Kikongo",
        nationalityKenyan: "Kikenya",
        nationalityRwandan: "Kirwanda",
        sex: "Jinsia",
        sexPlaceholder: "Chagua jinsia",
        sexMale: "Mume",
        sexFemale: "Mke",
        cv: "CV",
        coverLetter: "Barua ya Utambulisho",
        otherDocuments: "Nyaraka Zingine",
        experience: "Miaka ya Uzoefu",
        experiencePlaceholder: "Chagua kiwango cha uzoefu",
        experienceBeginner: "Mwanzo",
        experienceIntermediate: "Kati",
        experienceAdvanced: "Juu",
        startDate: "Tarehe ya Kuanza",
        submit: "Wasilisha",
        toastSuccessTitle: "Maombi yamewasilishwa.",
        toastSuccessDesc: "Maombi yako yamewasilishwa kwa mafanikio!",
        toastInvalidTitle: "Ingizo batili.",
        toastInvalidDesc: 'Sehemu ya "jinsia" lazima iwe "male" au "female".',
        toastNetworkTitle: "Hitilafu ya mtandao.",
        toastNetworkDesc: "Tafadhali angalia muunganisho wako wa mtandao na ujaribu tena.",
        toastFailedTitle: "Uwasilishaji umeshindikana.",
        imageAlt: "Maombi",
      },
      credit: {
        heroTitle: "Mikopo",
        title: "Mikopo Tunayoitoa",
        subtitle: "Mkopo unaosimamiwa vizuri hufungua njia kwa miradi mikubwa. Tunatoa aina tatu za mikopo inayolingana na mahitaji yako.",
        requirementsTitle: "Masharti ya Mikopo",
        requirementsSubtitle: "Ili kupata mkopo, wanachama wetu lazima watimize masharti yafuatayo.",
        conditionLabel: "Masharti",
        labelTaux: "Kiwango",
        labelRemboursement: "Malipo",
        labelEcheance: "Ukomo",
        labelGarantie: "Dhamana ya fedha",
        membershipNote: "Ili kupata mkopo, wanachama wetu lazima wajiunge na ushirika. Ada ya uanachama ni $20 na mwanachama lazima awe na angalau miezi 2 ya uanachama.",
        feesTitle: "Ada za kulipwa (zinazohusiana na mkopo)",
        feeDossier: "Ada ya kuchunguza faili",
        feeDecaissement: "Ada ya utoaji",
        feeAssurance: "Ada ya bima ya mkopo",
        feeCarnet: "Ada ya kitabu cha mkopo (kwa asiyekuwa nacho)",
        applyCta: "Omba mkopo",
      },
      epargne: {
        heroTitle: "Akiba",
        title: "Huduma Zetu za Akiba",
        subtitle: "Bidhaa salama za akiba zilizoundwa kukusaidia kujiandaa kwa mustakabali kwa kujiamini.",
        intro: "Akiba ya leo ni usalama wa kesho: kwa Akiba Courant yetu kwa miradi yako ya karibu na Akiba Maisha kujenga mustakabali wako.",
        ctaTitle: "Fungua Akaunti Mtandaoni",
        ctaText: "Anza kuweka akiba leo. Tuma ombi lako na timu yetu itawasiliana nawe kukamilisha ufunguzi wa akaunti yako.",
        ctaBtn: "Fungua Akaunti Yangu",
      },
      promotions: {
        heroTitle: "Matangazo",
        title: "Matangazo",
        subtitle: "Gundua matangazo yetu ya hivi karibuni na ofa maalum.",
        loading: "Inapakia...",
        errorPrefix: "Hitilafu",
        startDate: "Inaanza:",
        dueDate: "Inaisha:",
        comingSoon: "Hakuna matangazo kwa sasa. Rejea karibuni!",
      },
      realisations: {
        heroTitle: "Matendo",
        title: "Matendo Yetu",
        subtitle: "Gundua miradi na mafanikio ya COOPEC Microtous.",
        loading: "Inapakia...",
        errorPrefix: "Hitilafu",
        location: "Mahali:",
        comingSoon: "Hakuna matendo yaliyochapishwa kwa sasa. Rejea karibuni!",
      },
      admin: {
        title: "Dashibodi ya Admin",
        loginTitle: "Kuingia Admin",
        email: "Barua pepe",
        password: "Nenosiri",
        signIn: "Ingia",
        signOut: "Toka",
        tabPromotions: "Matangazo",
        tabRealisations: "Matendo",
        tabJobs: "Nafasi za kazi",
        tabApplications: "Maombi",
        newPromotion: "Matangazo mapya",
        newRealisation: "Kitendo kipya",
        newJob: "Tangazo lafasi mpya ya kazi",
        contractType: "Aina ya mkataba",
        contractFullTime: "Muda wa kamili",
        contractPartTime: "Muda wa sehemu",
        contractInternship: "Uandalizi wa kazi",
        contractTemporary: "Temporari",
        contractVolunteer: "Kujitolea",
        salary: "Mshahara",
        deadline: "Mwisho wa kuomba kazi",
        itemTitle: "Kichwa",
        description: "Maelezo",
        image: "Picha",
        startDate: "Tarehe ya kuanza",
        endDate: "Tarehe ya kuisha",
        location: "Mahali",
        publish: "Chapisha",
        unpublish: "Acha kuchapisha",
        draft: "Rasimu",
        publishImmediately: "Chapisha mara moja kwenye tovuti",
        update: "Sasisha",
        updated: "Mabadiliko yamehifadhiwa!",
        cancel: "Ghairi",
        editing: "Unarekebisha kipengele kilichopo.",
        removeImage: "Ondoa picha",
        notSpecified: "Haijasitishwa",
        delete: "Futa",
        confirmDelete: "Futa kipengele hiki? Hatua hii haiwezi kutenduliwa.",
        noItems: "Hakuna kilichochapishwa kwa sasa.",
        created: "Imechapishwa kwa mafanikio!",
        deleted: "Kipengele kimefutwa.",
        saving: "Inahifadhi...",
        loginError: "Barua pepe au nenosiri si sahihi.",
        notConfigured: "Supabase haijasanidiwa. Weka REACT_APP_SUPABASE_URL na REACT_APP_SUPABASE_ANON_KEY kwenye .env kisha anzisha upya programu.",
        imageRequired: "Tafadhali chagua picha.",
        invalidImageType: "Faili uliyochagua si picha.",
        fileTooLarge: "Picha ni kubwa mno. Ukubwa wa juu ni MB 5.",
        uploadForbidden: "Akaunti yako hairuhusiwi kupakia faili. Iongeze kwenye jedwali la admin_users kwenye Supabase (ona supabase/README.md).",
        notAdminWarning: "Akaunti hii haijasajiliwa kama msimamizi, kwa hiyo upakiaji na uchapishaji vitashindikana. Iongeze kwenye jedwali la admin_users kwenye Supabase (ona supabase/README.md).",
        titleRequired: "Tafadhali toa kichwa katika lugha moja au zaidi.",
        errorPrefix: "Hitilafu",
        noApplications: "Hakuna maombi yaliyopokelwa bado.",
        viewDocument: "Fungua waraka",
        cv: "CV",
        coverLetter: "Barua ya kujitambulisha",
        otherDocuments: "Nyaraka nyingine",
      },
      teams: {
        heroTitle: "Timu",
        title: "Timu Yetu",
        subtitle: "Kutana na akili nzuri nyuma ya mafanikio yetu. Timu yetu ndio msingi wa kampuni yetu.",
        seeAll: "Ona timu nzima",
      },
      footer1: {
        tagline: "Ushirika wa akiba na mikopo uliojitolea kujenga mustakabali wenye mafanikio na usalama wa kifedha kwa wanachama wetu wa Bunia.",
        links: "Viungo",
        home: "Nyumbani",
        about: "Kuhusu",
        services: "Huduma",
        contact: "Wasiliana",
        others: "Zingine",
        products: "Bidhaa",
        savings: "Akiba",
        credit: "Mikopo",
        healthInsurance: "Bima ya Afya",
        promotions: "Matangazo",
        activities: "Shughuli",
        contactTitle: "Wasiliana Nasi na Ratiba",
        address: "018 Avenue de l'Église, Kitongoji cha Ngezi, Commune ya Mbunya, Bunia, Ituri, DRC",
        email: "Barua pepe: info@microtous.com / support@microtous.com",
        phone: "Simu: +243 820 937 002",
        monFri: "Jumatatu hadi Ijumaa: 08:00 - 17:00",
        sat: "Jumamosi: 08:00 - 12:00",
        logoAlt: "Nembo ya kampuni",
        rights: "Haki zote zimehifadhiwa.",
        phoneNumber: "+243 820 937 002",
        emailAddress: "info@microtous.com / support@microtous.com",
        city: "Bunia, Ituri, DRC",
        downloadBrochure: "Pakua kijitabu chetu",
      },
      chatbot: {
        ariaLabel: "Zungumza nasi kwenye WhatsApp",
      },
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr',
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;